// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"imageQuestion__wrapper__37nEN","rotmanFadeLeft":"imageQuestion__rotmanFadeLeft__IX-Bt"};